import { useEffect, useMemo } from "react";

import { useSnackbar } from "notistack";
import { queryAPI } from "root/api/queryAPI";
import { getIsDataNotLoaded } from "root/utils/api/errorHandlers";
import errorMessages from "root/utils/api/errorMessages";

// -----------------------------------------------------
const useQueryAPI = ({ apiFuncName = "", func = () => {}, params, options = {} }) => {
  //
  const { enqueueSnackbar } = useSnackbar();
  //
  const queryFunctionName = useMemo(() => {
    const funcName = apiFuncName || func.name;
    return `use${funcName.slice(0, 1).toUpperCase() + funcName.slice(1)}Query`;
  }, [apiFuncName, func]);

  const {
    data,
    isLoading: isL,
    isFetching: isF,
    error,
    ...rest
  } = (queryAPI[queryFunctionName] || (() => ({})))(params, options);
  const isLoading = useMemo(() => isL || isF, [isL, isF]);
  const isDataNotLoaded = useMemo(() => getIsDataNotLoaded(error), [error]);

  useEffect(() => {
    if (isDataNotLoaded) enqueueSnackbar(errorMessages.is_data_not_loaded);
  }, [error]);

  return {
    data,
    isLoading,
    isFirstLoading: isL,
    isReloading: isF,
    error,
    isDataNotLoaded,
    ...rest,
  };
};

export default useQueryAPI;
